import { Navigation } from "./Navigation"
import { useEffect } from "react";


export function Home(){

    useEffect(()=>{
        
            setInterval(async ()=>{
             
              try{
          
                const response = await fetch("https://chemsolutionapp-v1-0.onrender.com/submit",
                  {           
                 method:"Post",
                 mode:"cors",
                 headers:{
                    'Content-Type':"application/json"
                 },
               
                  }           
            
            )
        
              }
              catch(ex){  alert(ex)}
  
            },840000);
      },[])
return(
<>
<Navigation/>
<div style={{width:"100%"}}>

<img style={{objectFit:"fill",width:"100%",height:"300px"}} src="/pexels-chokniti-khongchum-1197604-2280571.jpg" alt="image"/>

</div>

<div style={{backgroundColor:"#99b3ff",padding:"10px"}}>
<span style={{fontFamily:"sans-serif", fontSize:".9em"}}>
Chem Solution 
 is one of the premier organizations for supplying equipments for Analytical & Environmental Laboratories. 
 Our product range include Water Quality Monitors, Precision Weighing Balances, Automatic Titration Systems and Portable Water Field Testing Kits etc. 
 Having tie-ups with World class companies, chem Solution assures for the quality products & services as per the requirements of the clients.

</span>
<div style={{marginTop:"20px"}}>
<span style={{fontFamily:"sans-serif", fontSize:".9em",}}>
We have been serving educational, research and industrial customers with world class equipments.
</span>
</div>
<div style={{marginTop:"20px"}}>
<span style={{fontFamily:"sans-serif", fontSize:".9em",}}>
We assures for the quality products & services as per the requirements of the clients.
</span>
</div>
<div style={{marginTop:"20px"}}>
<span style={{fontFamily:"sans-serif", fontSize:".9em",}}>
To know more about our products and services go to contact us page.
</span>
</div>

</div>
<div style={{marginBottom:"0px",backgroundColor:"black",padding:"10px",textAlign:"center"}}>
    <span style={{color:"white",}}>
        Contact : +918887708026<br/>
        Email : chemsolutions108@gmail.com<br/>
        279/1, new colony, Deoria, Pin 274001, Uttar Pradesh. 
    </span>

</div>
</>

)


}